export enum SignalRSubscriptionState {
    justCreated = 0,
    activating = 1,
    activated = 2,
    failedToActivate = 3,
    toDeactivate = 4,
    deactivating = 5,
    deactivated = 6,
    failedToDeactivate = 7
}